import { AccountingBasis } from '@modules-deprecated/app/organization/types/accountingBasis'
import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

/**
 * Returns true when a suggestion should be suppressed because the suggested item is cash-based
 * and the bank transaction amount does not exactly match the item amount
 */
export const isCashBasedNonExactSuggestion = (
  suggestion: ReconciliationSuggestion,
  accountingBasis: AccountingBasis | undefined,
): boolean => {
  if (accountingBasis !== AccountingBasis.Cash) {
    return false
  }

  const reconcilable = suggestion.reconcilables[0]
  const transaction = suggestion.transactions[0]

  if (!reconcilable || !transaction) {
    return false
  }

  // Cross-currency: amount difference is expected, always allow
  if (reconcilable.currency !== transaction.currency) {
    return false
  }

  const transactionAmount = parseFloat(transaction.amount)

  // Fail open: if the amount can't be parsed, show the suggestion rather than suppress it
  if (isNaN(transactionAmount)) {
    return false
  }

  return Math.abs(reconcilable.amount) !== Math.abs(transactionAmount)
}
